// @flow
import React from 'react';
import get from 'app/common/lib/get';
import Checkbox from 'app/common/ui/Checkbox';
import LinkButton from 'app/components/Tariff/LinkButton';
import Confirmation from 'app/components/Tariff/Confirmation';
import confirmation from 'app/components/Tariff/Confirmation/confirmationState';
import SMSIndicator from '../../SMSIndicator';
import type { TariffType, Sub } from '../../Tariff';
import enhance from './enhance';

import styles from './SMSBundles.scss';


type Props = {
  sub: Sub,
  footnotes: Object,
  tariff: TariffType,
  state: string,
  confirmationState: string,
  handleConnect: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  handleBack: (e: SyntheticEvent<HTMLElement>) => void,
  handleChangeCurrent: (e: SyntheticEvent<HTMLElement>) => void,
  beginConfirmation: (e: SyntheticEvent<HTMLElement>) => void,
  stopConfirmation: (void) => void,
  currentBundleId: number,
  comment: string,
  bundleSubscribing: boolean,
  smsBundlesEnabled: boolean,
  t: (s: string) => string,
};

const SMSBundles = ({
  sub,
  footnotes,
  tariff,
  state,
  confirmationState,
  handleConnect,
  handleSubmit,
  handleBack,
  handleChangeCurrent,
  beginConfirmation,
  stopConfirmation,
  currentBundleId,
  comment,
  bundleSubscribing,
  smsBundlesEnabled,
  t,
}: Props) => (
  <div>
    {state === 'info'
      && <div className={styles.bundles}>
        <div>
          {t('sms_bundles')}
          {footnotes.smspack
            && <sup className={styles.fn}>{footnotes.smspack.index}</sup>}
        </div>
        <div className={styles.indicator}>
          <SMSIndicator smsCount={sub.sms_left} />
        </div>
        <div className={styles.buttons}>
          <LinkButton primary disabled={!smsBundlesEnabled} onClick={handleConnect}>
            {t('sms_bundles_refill_link')}
          </LinkButton>
        </div>
      </div>}

    {state === 'edit' && tariff.sms_bundles && !!tariff.sms_bundles.length
      && <div className={styles.bundles}>
        <div>
          {t('sms_bundles')}
          {footnotes.smspack && <sup className={styles.fn}>{footnotes.smspack.index}</sup>}
        </div>
        {tariff.sms_bundles && tariff.sms_bundles.map(item =>
          <Checkbox
            key={item.id}
            className={styles.small}
            name={`id${item.id}`}
            value={`id${item.id}`}
            onChange={handleChangeCurrent}
            checked={currentBundleId === item.id}
            label={
              <span className={styles.label}>
                <span>{item.title}</span>
                <span className={styles.cost}>{item.cost}</span>
              </span>
            }
          />)}
        <div className={styles.buttons}>
          <Confirmation
            onSubmit={handleSubmit}
            comment={comment}
            beginConfirmation={beginConfirmation}
            stopConfirmation={stopConfirmation}
          >
            {handle => (
              // $FlowFixMe
              <LinkButton
                primary
                onClick={handle}
                name="submit"
                disabled={!currentBundleId}
              >
                {bundleSubscribing
                  ? t('subscribe_link_loading')
                  : t('subscribe_link')}
              </LinkButton>)}
          </Confirmation>
          {!confirmationState
            && <LinkButton onClick={handleBack}>
              {t('back_link')}
            </LinkButton>}
        </div>
      </div>}

    {state === 'edit'
      && !get(tariff, 'sms_bundles.length', null)
      && <div className={styles.bundles}>
        {t('sms_bundles_not_available')}
        <div className={styles.buttons}>
          <LinkButton onClick={handleBack}>
            {t('back_link')}
          </LinkButton>
        </div>
      </div>}

  </div>
);

export default confirmation(enhance(SMSBundles));
